import { gql } from "@apollo/client/core";

// Q-006: Fetch current user's organizations with role
// Uses existing backend `myOrganizations` query
export const MY_ORGANIZATIONS_QUERY = gql`
  query MyOrganizations {
    myOrganizations {
      id
      name
      slug
      myRole
      memberCount
    }
  }
`;
